import { combine, withCallback, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { toaster } from 'utils/toast-wrapper'
import { admin } from 'routes/route.map'

import { StoreContext } from 'store/context'
import SponsorsAddComponent from './component'

export const SponsorsAdd = combine(
  withContext(
    'adminSponsorsService',
    ServicesContext,
    ({ adminSponsorsService }) => adminSponsorsService
  ),
  withContext('appStore', StoreContext),
  withCallback(
    'onSubmit',
    ({ adminSponsorsService, appStore }, { history }) =>
      async (sponsorDTO) => {
        const { fullName, ...form } = sponsorDTO

        await adminSponsorsService.createSponsor({
          ...form,
          sponsorFullName: fullName,
        })
        appStore.adminSponsors.onSponsorAdded()
        toaster.info('Sponsor has been successfully created')
        history.push(admin.sponsors())
      },
    []
  )
)(SponsorsAddComponent)
